/* eslint-disable no-unused-expressions */
import i18n from '@/plugins/i18n';
const multiSelectFieldGenerator = formItemAttr => {
  const ranges = [];
  const multiDef = [];
  formItemAttr.attr.range.split(',').forEach((range) => {
    const select = range.split(':');
    ranges.push({
      name: select[0].trim(),
      value: select[0].trim()
    }); // MML需要文字描述
  });
  formItemAttr.defValue = formItemAttr.defValue !== null ? formItemAttr.defValue.split(':')[0].trim() : null;
  multiDef.push(formItemAttr.defValue);

  let json = {trigger: "blur"};
  if(formItemAttr.validate.indexOf('required') !=-1 || formItemAttr.validate.indexOf('notNull') !=-1){
    json.required = true;
    }
  formItemAttr.validate = JSON.stringify(json);
  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: 'multi-select',
    type: 'Enum',
    validate: formItemAttr.validate,
    isForeign: formItemAttr.isForeign,
    foreignKey: formItemAttr.attr.foreignKey,
    vals: ranges,
    placeholder: '',
    def: multiDef,
    // TODO by s18857
    func: formItemAttr.func,
    asc: formItemAttr.index,
  };
};

const arrayFieldGenerator = formItemAttr => {
  console.log("array formItemAttr=",formItemAttr, formItemAttr.name);
  const ranges = [];
  const multiDef = [];
  formItemAttr.attr.range.split(',').forEach((range) => {
    const select = range.split(':');
  ranges.push({
    name: select[0].trim(),
    value: select[0].trim()
  }); // MML需要文字描述
});
  if(ranges.length === 0) {
    const range = formItemAttr.attr.range.split(',');
    for (let i = 0; i < range.length; i++) {
      range[i] = range[i].replace(/\(|\)/g, '');
    }
    // 当range[1]不存在时，将range[0]赋给range[1]
    if (!range[1]) {
      range[1] = range[0];
    }
  }

  formItemAttr.defValue = formItemAttr.defValue !== null ? formItemAttr.defValue.split(':')[0].trim() : null;
  multiDef.push(formItemAttr.defValue);

  let json = {trigger: "blur"};
  if(formItemAttr.validate.indexOf('required') !=-1 || formItemAttr.validate.indexOf('notNull') !=-1){
    json.required = true;
    }
  formItemAttr.validate = JSON.stringify(json);
  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: formItemAttr.isForeign?'multi-select':null,
    type: 'Text',
    validate: formItemAttr.validate,
    vals: formItemAttr.isForeign?undefined:ranges,
    placeholder: '',
    isForeign: formItemAttr.isForeign,
    foreignKey: formItemAttr.attr.foreignKey,
    def: multiDef,
    // TODO by s18857
    func: formItemAttr.func,
    asc: formItemAttr.index,
  };
};

const selectFieldGenerator = formItemAttr => {
  const ranges = [];
  formItemAttr.notNull === 'NO' && ranges.push({ name: '', value: '' });
  formItemAttr.attr.range.split(',').forEach((range) => {
    const select = range.split(':');
    ranges.push({
      name: select[0].trim(),
      value: select[0].trim()
    }); // MML需要文字描述
  });
  formItemAttr.defValue = formItemAttr.defValue !== null ? formItemAttr.defValue.split(':')[0].trim() : null;
  let json = {trigger: "blur"};

  if(formItemAttr.validate.indexOf('required') !=-1 || formItemAttr.validate.indexOf('notNull') !=-1){
    json.required = true;
    }
  formItemAttr.validate = JSON.stringify(json);

  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: 'form-select',
    type: 'Enum',
    validate: formItemAttr.validate,
    //下拉列表增加外键判断
    vals: formItemAttr.isForeign?undefined:ranges,
    placeholder: '',
    def: formItemAttr.defValue,
    // TODO by s18857
    func: formItemAttr.func,
    asc: formItemAttr.index,
    isForeign: formItemAttr.isForeign,
    foreignKey: formItemAttr.attr.foreignKey,
  };
};

const boolFieldGenerator = formItemAttr => {
  const ranges = [];
  formItemAttr.notNull === 'NO' && ranges.push({ name: '', value: '' });
  formItemAttr.attr.range.split(',').forEach((range) => {
    const select = range.split(':');
    ranges.push({
      name: select[0].toLocaleLowerCase().trim(),
      value: select[0].toLocaleLowerCase().trim()
    }); // MML需要文字描述
  });
  formItemAttr.defValue = formItemAttr.defValue ? 'true' : 'false';

  let json = {trigger: "blur"};
  if(formItemAttr.validate.indexOf('required') !=-1 || formItemAttr.validate.indexOf('notNull') !=-1){
    json.required = true;
    }
    if(formItemAttr.validate.indexOf('range') !=-1){
      if(parseInt(range[0], 0) === parseInt(range[1], 0)){
        json.range =[range[0],range[0]];
      }else{
        json.range =[range[0],range[1]];
      }
    }
  formItemAttr.validate = JSON.stringify(json);

  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: 'form-select',
    type: 'Enum',
    validate: formItemAttr.validate,
    vals: ranges,
    placeholder: '',
    def: formItemAttr.defValue,
    // TODO by s18857
    func: formItemAttr.func,
    asc: formItemAttr.index,
  };
};

const textFieldGenerator = formItemAttr => {
  const range = (parseInt(formItemAttr.attr.range, 0) - 1).toString();
  let json = {trigger: "blur",type:'text'};
  if(formItemAttr.validate.indexOf('required') !=-1 || formItemAttr.validate.indexOf('notNull') !=-1){
      json.required = true;
    }
  if(formItemAttr.validate.indexOf('maxSize') !=-1){
      json.maxLength = range;
    }
  formItemAttr.validate = JSON.stringify(json);

  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: formItemAttr.isForeign ? 'form-select' : null,
    type: 'Text',
    validate: formItemAttr.validate,
    placeholder: i18n.t('MML.maxBytesLength', [range]),
    def: formItemAttr.defValue,
    foreignKey: formItemAttr.attr.foreignKey,
    // TODO by s18857
    func: formItemAttr.func,
    isForeign: formItemAttr.isForeign,
    asc: formItemAttr.index,
  };
};

const ipv4FieldGenerator = formItemAttr => {
  let json = {trigger: "blur"};
  if(formItemAttr.validate.indexOf('required') !=-1 || formItemAttr.validate.indexOf('notNull') !=-1){
    json.required = true;
    }
  if(formItemAttr.validate.indexOf('ip') !=-1){
      json.regex = 'ipv4';
    }
  formItemAttr.validate = JSON.stringify(json);

  return{
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: formItemAttr.isForeign ? 'form-select' : null,
    type: 'Ipv4',
    validate: formItemAttr.validate,
    placeholder: i18n.t('MML.notValidIpv4'),
    def: formItemAttr.defValue,
    foreignKey: formItemAttr.attr.foreignKey,
    // TODO by s18857
    func: formItemAttr.func,
    isForeign: formItemAttr.isForeign,
    asc: formItemAttr.index,
  };
};

const ipv6FieldGenerator = formItemAttr => {
  let json = {trigger: "blur"};
  if(formItemAttr.validate.indexOf('required') !=-1 || formItemAttr.validate.indexOf('notNull') !=-1){
    json.required = [true,'required'];
    }
  if(formItemAttr.validate.indexOf('ip') !=-1){
    json.regex = 'ipv6';
   }
  formItemAttr.validate = JSON.stringify(json);

 return {
  zname: formItemAttr.zname,
  ename: formItemAttr.ename,
  name: formItemAttr.name,
  plugin: formItemAttr.isForeign ? 'form-select' : null,
  type: 'Ipv6',
  validate: formItemAttr.validate,
  placeholder: i18n.t('MML.notValidIpv6'),
  def: formItemAttr.defValue,
  foreignKey: formItemAttr.attr.foreignKey,
  // TODO by s18857
  func: formItemAttr.func,
  isForeign: formItemAttr.isForeign,
  asc: formItemAttr.index,
 }
 
};

const integerFieldGenerator = formItemAttr => {
  const range = formItemAttr.attr.range.split(',');
  for (let i = 0; i < range.length; i++) {
    range[i] = range[i].replace(/\(|\)/g, '');
  }
  // 当range[1]不存在时，将range[0]赋给range[1]
  if (!range[1]) {
    range[1] = range[0];
  }
  
  const jsonArrs=[];
  let json = {trigger: "blur"};

  if(formItemAttr.validate.indexOf('required') !=-1 || formItemAttr.validate.indexOf('notNull') !=-1){   
    json.required =true;
    }
  if(formItemAttr.validate.indexOf('integer') !=-1){
    json.regex ='/^[-+]?\d+$/';
    }
    if(formItemAttr.validate.indexOf('range') !=-1){
      const temArr = range.map(Number);
      json.range = temArr;
    }
  formItemAttr.validate = JSON.stringify(json);

  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: formItemAttr.isForeign ? 'form-select' : null,
    type: 'Number',
    validate: formItemAttr.validate,
    placeholder: parseInt(range[0], 0) === parseInt(range[1], 0) ? range[0] : `${range[0]} ~ ${range[1]}`,
    def: formItemAttr.defValue,
    foreignKey: formItemAttr.attr.foreignKey,
    // TODO by s18857
    func: formItemAttr.func,
    isForeign: formItemAttr.isForeign,
    asc: formItemAttr.index,
  };
};


const dateFieldGenerator = formItemAttr => {
  const range = (parseInt(formItemAttr.attr.range, 0) - 1).toString();
  let json = {trigger: "blur",type:'text'};
  if(formItemAttr.validate.indexOf('required') !=-1 || formItemAttr.validate.indexOf('notNull') !=-1){
      json.required = true;
    }
  if(formItemAttr.validate.indexOf('maxSize') !=-1){
      json.maxLength = range;
    }
  formItemAttr.validate = JSON.stringify(json);

  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: formItemAttr.isForeign ? 'form-select' : null,
    type: 'Date',
    validate: formItemAttr.validate,
    placeholder: i18n.t('MML.maxBytesLength', [range]),
    def: formItemAttr.defValue,
    foreignKey: formItemAttr.attr.foreignKey,
    // TODO by s18857
    func: formItemAttr.func,
    isForeign: formItemAttr.isForeign,
    asc: formItemAttr.index,
  };
};


const fieldGenerator = {
  multienum: multiSelectFieldGenerator,
  enum: selectFieldGenerator,
  bool: boolFieldGenerator,
  text: textFieldGenerator,
  ipv4: ipv4FieldGenerator,
  ipv6: ipv6FieldGenerator,
  array: arrayFieldGenerator,
  date: dateFieldGenerator,
  time: dateFieldGenerator,
  default: integerFieldGenerator,
};
export default fieldGenerator;
